import { pushDataLayer } from "~/hec/analytics/data-layer.client";

import type { ZmagsDetails } from "./types";

/**
 * Legacy Fastr `zmags` interaction event (`trackFilterEvent`), GTM forwards it as GA4 `zmags`.
 * pushDataLayer, not pushEvent: `zmags` has no fork key and fork.ts is left alone (D43).
 */
const buildZmagsEvent = (
  exp: string,
  int: string,
  { scene = "", url = "", value = "" }: ZmagsDetails,
) => ({
  event: "zmags",
  zmags_exp: exp,
  zmags_exp_type: "experience",
  zmags_int: int,
  zmags_scene: scene,
  zmags_url: url,
  zmags_value: value,
});

export const emitZmags = (
  exp: string,
  int: string,
  details: ZmagsDetails,
): void => pushDataLayer(buildZmagsEvent(exp, int, details));
